import { safeJsonParse } from "@/zapi-frontend/utils/safeJsonParse";

export const removeContentFromResponse = (responseStringifiedJson: string) => {
  const parsed = safeJsonParse(responseStringifiedJson);
  if (parsed?.type === "answer" || parsed?.type === "agent") {
    return responseStringifiedJson;
  }

  const parsedWithReplacedContent = { ...parsed, content: "Assistant responded" };
  return JSON.stringify(parsedWithReplacedContent);
};
